import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import ContactFormModal from './ContactFormModal';
import { analyticsTrack } from '../../analyticsUtils';
import './ContactSupportBanner.scss';

const handleAddProject = () => {
  analyticsTrack('Clicked Add Project on search banner', { location: 'Search Index' });
  window.location.href = '/projects/add_project';
};

function ContactSupportBanner(props) {
  return (
    <div className="support-hero">
      <div className="content">
        <strong>
          <i className="fas fa-hand-point-right mr-12" />
          Looking for a different expertise?
        </strong>
        {' '}
        Clora&apos;s Operations team can assist you with any functional need.
        <span className="btn-group">
          <Button
            variant="secondary btn-project"
            onClick={handleAddProject}
          >
            <i className="fas fa-plus" />
            Add Project
          </Button>
          <ContactFormModal
            {...props}
          />
        </span>
      </div>
    </div>
  );
}

ContactSupportBanner.propTypes = {
  csrfToken: PropTypes.string.isRequired,
};

export default ContactSupportBanner;
